
import styles from '../css/FormCheck.module.scss';

export const FormCheck = ({ id, idCheck, checked, text, onChange }) => {

    const handleChange = () => {
        onChange({id, text}); 
    };

    return (
        <div class="form-check ">
            <input class={"form-check-input " + styles.formCheck} type="checkbox" checked={checked} id={"check" + idCheck} onChange={handleChange} />
            <label class="form-check-label" for={"check" + idCheck} >
                {text}
            </label>
        </div>
    );
}